import React, { FC } from 'react';
import { Button } from 'components/Buttons';
import TypographyComponent from 'components/Typography/Typography';
import pxToEm from 'theme/pxToEm';
import * as Styled from './ContactRepModalView.styles';

interface EmptyStateProps {
  onButtonClick: () => void;
  isError?: boolean;
}

const defaultText = 'Sorry, there are no Brand Reps listed for this product';
const errorText = 'Sorry, looks like an error occurred. Please try again later';

export const EmptyState: FC<EmptyStateProps> = ({ onButtonClick, isError }) => {
  return (
    <Styled.StatusMessage>
      <TypographyComponent variant="body" sx={{ marginBottom: pxToEm(20) }}>
        {isError ? errorText : defaultText}
      </TypographyComponent>
      <Button
        variant="contained"
        color="secondary"
        size="medium"
        onClick={onButtonClick}
      >
        Close
      </Button>
    </Styled.StatusMessage>
  );
};
